import { FrontendProductSchema } from "@redotech/redo-agents-cards/support-agents/frontend-product";
import * as z from "zod";

export const searchProducts = {
  name: "searchProducts" as const,
  input: z.object({ query: z.string() }),
  output: z.array(FrontendProductSchema),
};
